import { Title } from "@dropbox/dig-components/typography";
import { Box } from "@dropbox/dig-foundations";
import { OmniboxErrorBoundary } from "@mirage/mosaics/Omnibox/components/OmniboxErrorBoundary";
import { getTimeOfDayGreetingWithName } from "@mirage/mosaics/StartPage/Calendar/utils";
import { useName } from "@mirage/service-auth/useName";
import { useFeatureFlagValueBool } from "@mirage/service-experimentation/useFeatureFlagValue";
import { useIsMobileSize } from "@mirage/shared/responsive/mobile";
import cx from "classnames";
import { PersistedOmnibox } from "../Omnibox/withPersistedOmniboxSurface";
import { QuerySuggestions } from "../QuerySuggestions/QuerySuggestions";
import styles from "./GreeterHeader.module.css";

export const GreeterHeader = () => {
  const isMobile = useIsMobileSize();

  // This is redundant but adding for safety in case the greeter header gets used before April 24th
  const isOmniboxEnabled = useFeatureFlagValueBool("dash_2025_03_18_omnibox");
  const isQuerySuggestionsEnabled = useFeatureFlagValueBool(
    "dash_2025_03_24_search_and_answer_suggestions",
  );

  const { firstName } = useName();

  return (
    <Box
      className={cx(
        styles.greeterHeaderWrapper,
        {
          [styles.mobile]: isMobile,
        },
        "meticulous-redact-recording",
      )}
    >
      <Box className={styles.greeterHeaderContainer}>
        <Title
          weightVariant="emphasized"
          size="large"
          className={styles.titleWrapper}
        >
          {getTimeOfDayGreetingWithName(firstName)}
        </Title>
      </Box>
      {isOmniboxEnabled && (
        <OmniboxErrorBoundary>
          <PersistedOmnibox shouldMemoize={true} />
        </OmniboxErrorBoundary>
      )}
      {isQuerySuggestionsEnabled && <QuerySuggestions />}
    </Box>
  );
};

GreeterHeader.displayName = "GreeterHeader";
